export default __webpack_public_path__ + "376f3e84a71645280df08495dc51fa93.svg";